import { render } from "./ContentsMessagePart.vue?vue&type=template&id=4def3598"
import script from "./ContentsMessagePart.vue?vue&type=script&lang=ts"
export * from "./ContentsMessagePart.vue?vue&type=script&lang=ts"
script.render = render

export default script